import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { client, ClientMethodsTypes } from '@/services/v2/client'
import { NotificationDTO, NotificationsQueryKeys } from '../types/notifications'
import { useUser } from 'containers/user/hooks/useUser'

const BASE_URL = '/api/v1/notifications'
const FIVE_MINUTES = 1000 * 60 * 5

export const useNotifications = () => {
  const { user } = useUser()
  const { data, ...rest } = useQuery({
    queryKey: [NotificationsQueryKeys.NOTIFICATIONS],
    queryFn: () => client<NotificationDTO[]>(`${BASE_URL}`),
    enabled: !!user?.id,
    cacheTime: FIVE_MINUTES,
    refetchInterval: FIVE_MINUTES,
  })

  return {
    ...rest,
    data: (data || []).sort((a, b) => b.createdOn - a.createdOn),
    newNotifications: (data?.filter((notification) => !notification.read) || []).length,
  }
}

export const useMarkNotificationAsRead = () => {
  const queryClient = useQueryClient()
  
  return useMutation({
    mutationFn: (ids: string[]) => {
      const notificationsIdsQuery = ids.map((id) => `notificationIds=${id}`).join('&')
      return client(`${BASE_URL}/mark-as-read?${notificationsIdsQuery}`, {
        method: ClientMethodsTypes.PUT,
      })
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries([NotificationsQueryKeys.NOTIFICATIONS])
    },
  })
}
